const state = {
    kyc_client_id: null,
    kyc_client: {
        first_name: '',
        last_name: '',
        email: '',
        phone: ''
    },
    kyc_files: {
        document_file_id: null,
        face_file_id: null,
        registration_file_id: null,
    },
    kyc_verification_type: null,
    kyc_partner_login: null,
}

const getters = {
    StateKycClientId: (state) => state.kyc_client_id,
    StateKycClient: (state) => state.kyc_client,
    StateKycFiles: (state) => state.kyc_files,
    StateKycVerificationType: (state) => state.kyc_verification_type,
    StateKycPartnerLogin: (state) => state.kyc_partner_login,
}

const actions = {
    async ActionSetKycClientId({ commit }, id) {
        try { await commit('setKycClientId', id) } catch {}
        return true
    },
    async ActionSetKycClientInfo({ commit }, client) {
        try { await commit('setKycClientInfo', client) } catch {}
        return true
    },
    async ActionSetKycDocumentFileId({ commit }, id) {
        try { await commit('setKycDocumentFileId', id) } catch {}
        return true
    },
    async ActionSetKycFaceFileId({ commit }, id) {
        try { await commit('setKycFaceFileId', id) } catch {}
        return true
    },
    async ActionSetKycRegistrationFileId({ commit }, id) {
        try { await commit('setKycRegistrationFileId', id) } catch {}
        return true
    },
    async ActionSetKycVerificationType({ commit }, type) {
        try { await commit('setKycVerificationType', type) } catch {}
        return true
    },
    async ActionSetKycPartnerLogin({ commit }, login) {
        try { await commit('setKycPartnerLogin', login) } catch {}
        return true
    },
    async ActionResetKycClientData({ commit }) {
        try { await commit('resetKycClientData') } catch {}
        return true
    },
}

const mutations = {
    setKycClientId(state, id) {
        state.kyc_client_id = id || null
    },
    setKycClientInfo(state, client) {
        state.kyc_client = {
            first_name: client?.first_name || '',
            last_name: client?.last_name || '',
            email: client?.email || '',
            phone: client?.phone || ''
        }
    },
    setKycDocumentFileId(state, id) {
        state.kyc_files.document_file_id = id || null
    },
    setKycFaceFileId(state, id) {
        state.kyc_files.face_file_id = id || null
    },
    setKycRegistrationFileId(state, id) {
        state.kyc_files.registration_file_id = id || null
    },
    setKycVerificationType(state, type) {
        state.kyc_verification_type = type || null
    },
    setKycPartnerLogin(state, login) {
        state.kyc_partner_login = login || null
    },
    resetKycClientData(state) {
        state.kyc_client_id = null
        state.kyc_client = { first_name: '', last_name: '', email: '', phone: '' }
        state.kyc_files = { document_file_id: null, face_file_id: null, registration_file_id: null }
        state.kyc_verification_type = null
        state.kyc_partner_login = null
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
